// extracted by mini-css-extract-plugin
module.exports = {"breadcrumb_wrapper":"Breadcrumb_breadcrumb_wrapper__2j9-U","item_box":"Breadcrumb_item_box__3pUhO","breadcrumb_item":"Breadcrumb_breadcrumb_item__3NHwX"};